import { Chart, ChartOption } from '@/components/Base/Chart.tsx';
import { formatLargeNumber } from '@/utils/formatLargNumber';
import { Box, Typography } from '@mui/material';

const ColumnChartContasRecebidasAtraso = ({ rawData }) => {
  const daysArray = [];
  const realValueData = [];
  const lateValueData = [];

  rawData.forEach((data) => {
    daysArray.push(`${data.day}`);
    realValueData.push(data.real_value);
    lateValueData.push(data.late_value);
  });

  const series = [
    {
      data: lateValueData,
      type: 'bar',
      name: 'Valor recebido em atraso',
      itemStyle: {
        borderRadius: [10, 10, 0, 0],
        color: '#679dd7',
      },
      label: {
        show: true,
        padding: [5, 10],
        borderRadius: [5],
        position: 'top',
        formatter: (params) => formatLargeNumber(Number(params.value)),
      },
    },
  ];

  const option = {
    legend: {
      data: [
        { name: 'Valor recebido em atraso' },
      ],
      right: '0',
      icon: 'circle',
      textStyle: {
        rich: {
          redDot: {
            color: 'rgba(224, 74, 76, 1)',
            fontSize: 14,
            padding: [0, 5],
          },
          right: '0%',
          top: '5%',
          orient: 'horizontal',
          blueDot: {
            color: 'rgba(21, 171, 81, 1)',
            fontSize: 14,
            padding: [0, 5],
          },
        },
      },
    },
    grid: {
      top: '15%',
      bottom: '20%',
      left: '5%',
      right: '5%',
    },
    yAxis: {
      type: 'value',
    },
    xAxis: {
      type: 'category',
      data: daysArray,
      axisLabel: {
        formatter: (value) => value,
      },
    },
    tooltip: {
      trigger: 'axis',
      formatter: (params) => {
        const day = params[0].name;
        const pagoValue = params[0].value;
        return `
          <div>
            <strong>dia ${day}</strong><br />
            Recebido: ${formatLargeNumber(pagoValue)}<br />
          </div>
        `;
      },
    },
    series,
  } as ChartOption;

  return (
    <Box sx={{ boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)' }} height={'400px'} p={2}>
      <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 1 }}>
        Contas recebidas com atraso
      </Typography>
      <Chart option={option} />
    </Box>
  );
};

export default ColumnChartContasRecebidasAtraso;
